export default __webpack_public_path__ + "static/tokyo_dog_cat_weather-beaec172bef77af398b94709402ce5de.jpg";